import { render, staticRenderFns } from "./UnitModal.vue?vue&type=template&id=babdb40a&"
import script from "./UnitModal.vue?vue&type=script&lang=js&"
export * from "./UnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('babdb40a')) {
      api.createRecord('babdb40a', component.options)
    } else {
      api.reload('babdb40a', component.options)
    }
    module.hot.accept("./UnitModal.vue?vue&type=template&id=babdb40a&", function () {
      api.rerender('babdb40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/UnitModal.vue"
export default component.exports